export default __webpack_public_path__ + "static/media/FacebookClone.7d180d9e.jpg";